// removed by extract-text-webpack-plugin
module.exports = {"root":"_3F_rr","input":"_1nhXD","checkIcon":"_1MDap","label":"_2r8LI"};


//////////////////
// WEBPACK FOOTER
// ./app/components/fields/Checkbox/Checkbox.scss
// module id = 1506
// module chunks = 1